import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { UserStore } from '../store/user.store';

export const hasDamageRole: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  return userStore.user$.pipe(
    filter(user => !!user),
    take(1),
    map(() => {
      // Accepts EITHER path during the parallel-run migration window:
      //   new-system users → effective_roles is non-empty
      //   legacy users     → dmg_groups is non-empty
      // After migration cutover: replace with resolvedRoles check only.
      const hasRole = userStore.resolvedRoles().length > 0;
      return hasRole || router.parseUrl('/access-denied');
    })
  );
};
